import { FC } from 'react';

import { IIconProps } from '../types';

const ContentControlIcon: FC<IIconProps> = ({ className }) => (
  <i className={`content-control-icon icon ${className}`} />
);

export default ContentControlIcon;
